module.exports = __webpack_public_path__ + "static/assets/306ffbcffad0d931fb1d158dd812f3fe.svg";